"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryTable = exports.eJoinType = void 0;
var TextUtils_1 = require("../../Utils/TextUtils");
var eJoinType;
(function (eJoinType) {
    eJoinType[eJoinType["eLeftJoin"] = 0] = "eLeftJoin";
    eJoinType[eJoinType["eRightJoin"] = 1] = "eRightJoin";
    eJoinType[eJoinType["eInnerJoin"] = 2] = "eInnerJoin";
})(eJoinType = exports.eJoinType || (exports.eJoinType = {}));
;
var QueryTable = /** @class */ (function () {
    /**
     * Construye una tabla de una sentencia SELECT
     *
     * @param Name  Nombre de la tabla en la base de datos.
     * @param Alias Alias de la tabla en la unión JOIN del SQL.
     */
    function QueryTable(Name, Alias) {
        this.m_bUseParrentisisAtJoins = false;
        // Almacenar estos datos que son los básicos
        this.m_strTableName = Name;
        this.m_strTableAlias = Alias;
        // Por defecto usamos prefijo
        this.m_bUsePrefix = true;
        // K11090501: El parser de SQL no almacena el tipo de JOIN. Debería.
        this.m_joinType = eJoinType.eLeftJoin;
    }
    /**
     * Devuelve la siguiente tabla en una cadena de JOINs.
     *
     * @return
     */
    QueryTable.prototype.getSecondTable = function () {
        return this.m_secondTable;
    };
    /**
     * Asigna valor a la siguiente tabla en la cadena de JOINs.
     *
     * @param value Tabla que sigue a esta en la cadena de JOINS de la sentencia SQL.
     */
    QueryTable.prototype.setSecondTable = function (value) {
        this.m_secondTable = value;
    };
    /**
     * M09072901:	Permitir que se puedan traducir los joins a formato where en blackberry
     * Expone la bandera que indica si hay que traducir las uniones o no.
     */
    QueryTable.prototype.getTranslateJoins = function () {
        return this.m_bTranslateJoins;
    };
    /**
     * M09072901:	Permitir que se puedan traducir los joins a formato where en blackberry
     * Asigna valor a la bandera que indica si hay que traducir las uniones o no. Si hay tabla
     * secundaria le propaga el valor que se le haya indicado.
     */
    QueryTable.prototype.setTranslateJoins = function (value) {
        this.m_bTranslateJoins = value;
        if (this.m_secondTable != null) {
            this.m_secondTable.setTranslateJoins(value);
        }
    };
    /**
     * @return Devuelve el nombre real de la tabla.
     */
    QueryTable.prototype.getActualName = function () {
        if (!this.m_bUsePrefix) {
            return this.m_strTableName;
        }
        return "##PREF##" + this.m_strTableName;
    };
    /**
     * Devuelve o asigna el alias a la tabla
     *
     * @return Esta función devuelve el alias de la tabla en la sentencia SQL a que pertenece.
     */
    QueryTable.prototype.getAlias = function () {
        return this.m_strTableAlias;
    };
    /**
     * Asigna valor al alias de la tabla en la sentencia SQL a que pertenece.
     *
     * @param value Nuevo valor para el alias de la tabla en la sentencia.
     */
    QueryTable.prototype.setAlias = function (value) {
        this.m_strTableAlias = value;
    };
    /**
     * @return Devuelve la condición de unión entre esta tabla y la que le sigue.
     */
    QueryTable.prototype.getJoinCondition = function () {
        return this.m_strJoinCondition;
    };
    /**
     * K11090501: El parser de SQL no almacena el tipo de JOIN. Debería.
     * Exponer el tipo de join
     *
     * @return
     */
    QueryTable.prototype.getJoinType = function () {
        return this.m_joinType;
    };
    /**
     * Asigna valor a la condición de unión entre esta tabla y la que le sigue en la sentencia.
     * <p>
     * K11090501: El parser de SQL no almacena el tipo de JOIN. Debería.
     * Pasar el tipo de join también
     *
     * @param value Nuevo valor para la condición de unión.
     */
    QueryTable.prototype.setJoinCondition = function (value, Type) {
        this.m_strJoinCondition = value;
        // K11090501: El parser de SQL no almacena el tipo de JOIN. Debería.
        this.m_joinType = Type;
    };
    /**
     * @return Devuelve una cadena de unión con esta tabla y las que le siguen en la cadena de JOINs.
     */
    QueryTable.prototype.getTableName = function () {
        var str, strTmp;
        // Si no tiene segunda tabla, solamente es esta
        if (this.m_secondTable == null) { // No hay unión
            str = String.format("%s%s", this.m_bUsePrefix ? "##PREF##" : "", this.m_strTableName);
            return str;
        } // No hay unión
        // M09072901:	Permitir que se puedan traducir los joins a formato where en blackberry
        // Ahora tenemos que ver si hay traducción de uniones, en cuyo caso habrá que devolver otra cosa
        if (this.m_bTranslateJoins) {
            return this.TranslatedJoinTableName();
        }
        // m_bUseParrentisisAtJoins
        var openParent = "(";
        var closeParent = ")";
        if (!this.m_bUseParrentisisAtJoins) {
            openParent = "";
            closeParent = "";
        }
        //
        // Si tiene segunda tabla, devolver la unión de ambas
        str = openParent + this.m_secondTable.getTableName();
        if (TextUtils_1.default.isEmpty(this.m_secondTable.getJoinCondition())) { // Incluir el alias
            strTmp = " " + this.m_secondTable.getAlias();
            str += strTmp;
        } // Incluir el alias
        //
        // Adicionar las uniones y esas cosillas
        // K11090501: El parser de SQL no almacena el tipo de JOIN. Debería.
        var strJoin = "LEFT OUTER JOIN";
        switch (this.m_joinType) {
            case eJoinType.eRightJoin:
                strJoin = "RIGHT JOIN";
                break;
            case eJoinType.eInnerJoin:
                strJoin = "INNER JOIN";
                break;
        }
        strTmp = String.format(" %s %s%s %s ON %s" + closeParent, strJoin, this.m_bUsePrefix ? "##PREF##" : "", this.m_strTableName, this.m_strTableAlias, this.m_strJoinCondition);
        str += strTmp;
        return str;
    };
    /**
     * M09072901:	Permitir que se puedan traducir los joins a formato where en blackberry
     * Devuelve una cadena con los nombres de tablas pero traduciendo las uniones a formato filtrado.
     */
    QueryTable.prototype.TranslatedJoinTableName = function () {
        var strOut = this.m_bUsePrefix ? "##PREF##" : "";
        strOut += this.m_strTableName;
        // Ahora tendremos que poner el alias si lo lleva
        if (!TextUtils_1.default.isEmpty(this.m_strTableAlias)) {
            strOut += (" " + this.m_strTableAlias);
        }
        // Y finalmente si hay siguiente tabla habrá que concatenarla
        if (this.m_secondTable != null) {
            strOut += ("," + this.m_secondTable.TranslatedJoinTableName());
        }
        return strOut;
    };
    /**
     * Asigna valor al nombre (real) de la tabla en la sentencia SQL a la que pertenece.
     *
     * @param value Nuevo valor para el nombre de la tabla.
     */
    QueryTable.prototype.setTableName = function (value) {
        this.m_strTableName = value;
    };
    /**
     * @return Devuelve la bandera que indica si la tabla usa prefijo o no.
     */
    QueryTable.prototype.getUsePrefix = function () {
        return this.m_bUsePrefix;
    };
    /**
     * Asigna valor a la bandera que indica que hay que usar prefijo al recomponer el SQL.
     *
     * @param value TRUE si se quiere incluir el prefijo al recomponer el SQL.
     */
    QueryTable.prototype.setUsePrefix = function (value) {
        this.m_bUsePrefix = value;
    };
    /**
     * M09072901:	Permitir que se puedan traducir los joins a formato where en blackberry
     * Devuelve las condiciones para insertar en el WHERE generado como consecuencia de la
     * traducción de las uniones. Si ya había WHERE se adicionarán al que había, si no lo hay
     * se generará uno nuevo.
     */
    QueryTable.prototype.getTranslatedJoinConditions = function () {
        var strOut = "";
        // Obtener la condición de la primera tabla
        if (!TextUtils_1.default.isEmpty(this.m_strJoinCondition)) {
            strOut += ("(" + this.m_strJoinCondition + ")");
        }
        if (this.m_secondTable != null) { // Pedir la condición de esa tabla
            var strTmp = this.m_secondTable.getTranslatedJoinConditions();
            if (!TextUtils_1.default.isEmpty(strTmp)) {
                strOut += (" AND " + strTmp);
            }
        } // Pedir la condición de esa tabla
        return strOut;
    };
    return QueryTable;
}());
exports.QueryTable = QueryTable;

//# sourceMappingURL=QueryTable.js.map
